import { FC, useEffect, useState } from "react";

import { BigNumber } from "../../classes/BigNumber";
import { blockchain } from "../../settings";
import { useStoreSelector } from "../../store/store";
import { Deposit } from "../../utils/Chromia/operations";
import { updateDeposits } from "../../utils/helpers";

import ConnectionButton from "../ConnectionButton/ConnectionButton";
import DepositBlock from "../DepositsBlock/DepositsBlock";
import DiscountSelector from "../DiscountSelector/DiscountSelector";
import Header from "../Header/Header";
import Button from "../UI/Button/Button";
import Input from "../UI/Input/Input";

import './MainPage.scss';


const MainPage: FC = () => {
	const {userAddress, discountPercent, fTokens, appContracts, apiData, minDeposits} = useStoreSelector(store => store.app);
	const {isDepositAvailable} = useStoreSelector(store => store.UI);

	const [amount, setAmount] = useState('');
	const [isAmountInvalid, setIsAmountInvalid] = useState(false);

	const deposit = async () => {
		if (!amount) return;
		switch (blockchain) {
			case 'binance':
				if (
					!userAddress ||
					!fTokens[discountPercent] ||
					!apiData[discountPercent] ||
					!appContracts[discountPercent]
				) throw new Error('');

				const amountBN = new BigNumber(amount);

				const balance = new BigNumber( await fTokens[discountPercent]!.contract.methods.balanceOf(userAddress).call() );
				if (balance.valueBN18.lt(amountBN.valueBN18)){
					throw new Error('')
				}
				const allowance = new BigNumber( await fTokens[discountPercent]!.contract.methods.allowance(userAddress, apiData[discountPercent]!.config.sbd.adr).call() );
				if (allowance.valueBN18.lt(amountBN.valueBN18)){
					// approve
					await fTokens[discountPercent]!.contract.methods.approve(apiData[discountPercent]!.config.sbd.adr, amountBN.getDecBN()).send({from: userAddress, gas: 3000000, gasPrice: '5000000000'});
				}

				/* const receipt = */ await appContracts[discountPercent]!.methods.Deposit(amountBN.getDecBN()).send({from: userAddress, gas: 3000000, gasPrice: '5000000000'});
				// console.log('Deposit: ', receipt)
				setTimeout(() => {
					updateDeposits(discountPercent);
				}, 1000);
				break;

			case 'chromia':
				Deposit(amount);
				break;

			default:
				throw new Error('');
		}
	}

	useEffect(() => {
		setIsAmountInvalid(
			minDeposits[discountPercent]
				? minDeposits[discountPercent]!.valueBN18.gt(new BigNumber(amount).valueBN18)
				: false
		);
	}, [amount, discountPercent, minDeposits])
	useEffect(() => {
		minDeposits[discountPercent] && setAmount(minDeposits[discountPercent]!.valueStr);
	}, [discountPercent, minDeposits])


	return (
		<div>
			<Header/>

			<div className="MainPage">
				<div className="MainPage-leftPart">
					<div className="MainPage-leftPart-title">
						<div>
							<span className="MainPage-leftPart-title-gradient">Stake USDT</span> and <span className="MainPage-leftPart-title-gradient">get CHR</span>
						</div>
						<div>
							at discount from market price
						</div>
					</div>
					
					<div className="MainPage-leftPart-subtitle">
						Once you’ve deposited USDT, you will be able to buy CHR at the selected discount when the price drops by a given percentage or receive an estimated APR on the staked USDT if the price rises
					</div>

					<DepositBlock/>

					<div className="MainPage-leftPart-periods">
						<div>
							Interest Period <span className="MainPage-leftPart-periods-gradient">1 Day</span>
						</div>
						<div className="MainPage-leftPart-periods-divider"/>
						<div>
							Redemption Period <span className="MainPage-leftPart-periods-gradient">1 Day</span>
						</div>
					</div>
				</div>

				<div className="MainPage-divider"/>

				<div className="MainPage-rightPart">
					<div className="MainPage-rightPart-aprBlock">
						<div>
							Total APR
							<div className="MainPage-rightPart-aprBlock-percent">
								8.5%-12.0%
							</div>
						</div>
						
						<div>
							Bonus APR
							<div className="MainPage-rightPart-aprBlock-percent">
								5% (CHR)
							</div>
						</div>

						<div>
							Estimated staking APR
							<div className="MainPage-rightPart-aprBlock-percent">
								3.5%-7.0%
							</div>
						</div>
					</div>

					<div className="MainPage-rightPart-discountBlock">
						<div className="MainPage-rightPart-discountBlock-title">Choose discount:</div>
						<DiscountSelector/>
					</div>
					{(userAddress && isDepositAvailable[discountPercent]) &&
						<div className="MainPage-rightPart-inputBlock">
							<div className="MainPage-rightPart-inputBlock-title">Deposit amount:</div>
							<div
								className="MainPage-rightPart-inputBlock-inputRow"
							>
								<Input
									value={amount}
									setValue={setAmount}
									invalid={isAmountInvalid}
									setInvalid={setIsAmountInvalid}
									// showInvalidHint={false}
									placeholder="USDT amount"
									className="MainPage-rightPart-inputBlock-inputRow-input"
									type="number"
									minValue={minDeposits[discountPercent]? +minDeposits[discountPercent]!.valueStr : undefined}
									notNull
									// negativeValues
								/>
								{(isAmountInvalid && minDeposits[discountPercent]) &&
									<div className="MainPage-rightPart-inputBlock-inputRow-text">
										(Min value: {minDeposits[discountPercent]!.valueStr} USDT)
									</div>
								}
							</div>
						</div>
					}
					{userAddress?
						<Button
							className="MainPage-rightPart-button"
							action={deposit}
							disabled={isAmountInvalid || !amount}
						>
							Deposit
						</Button>
					:
						<ConnectionButton
							className="MainPage-rightPart-button"
						/>
					}
				</div>
			</div>
		</div>
	)
}

export default MainPage;